// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3eEW1","left":"InfoRow_left__3aMZy"};